import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import atomize from "@quarkly/atomize";
import Link from "./link";
var PrimitiveButton = atomize.button();

var Button = function Button(_ref) {
  var href = _ref.href,
      target = _ref.target,
      type = _ref.type,
      otherProps = _objectWithoutProperties(_ref, ["href", "target", "type"]);

  if (type !== "link") {
    return /*#__PURE__*/React.createElement(PrimitiveButton, _extends({
      type: type
    }, otherProps));
  }

  return /*#__PURE__*/React.createElement(Link, _extends({
    href: href,
    target: target
  }, otherProps));
};

export default atomize(Button)({
  name: "Button",
  effects: {
    hover: ":hover",
    focus: ":focus",
    active: ":active",
    disabled: ":disabled",
    firstChild: ":first-child",
    lastChild: ":last-child",
    onlyChild: ":only-child",
    firstOfType: ":first-of-type",
    lastOfType: ":last-of-type",
    onlyOfType: ":only-of-type",
    before: ":before",
    after: ":after"
  },
  description: {
    en: "button element — button that performs an action. For example, can be used in forms to submit data",
    ru: "Элемент button — кнопка, которая выполняет какое-либо действие. Например, отправка данных формы"
  },
  forwardCssProperties: false,
  propInfo: {
    type: {
      control: "select",
      variants: ["submit", "button", "link"],
      category: "Main"
    },
    disabled: {
      control: "checkbox",
      category: "Main"
    },
    href: {
      weight: 1,
      control: "href",
      category: "Main",
      description: {
        en: "href — destination address where the link takes to",
        ru: "href — адрес назначения, по которому направляет ссылка"
      }
    },
    target: {
      weight: 1,
      control: "select",
      variants: ["_self", "_blank", "_parent", "_top"],
      category: "Main"
    }
  }
}, {
  type: "submit",
  "disabled-background": "--color-grey",
  "focus-box-shadow": "0 0 0 2px --color-primary",
  "border-width": "0px",
  "border-style": "none",
  background: "--color-primary",
  color: "--light",
  appearance: "button",
  cursor: "pointer",
  overflow: "visible",
  outline: "none",
  "user-select": "none",
  "box-sizing": "border-box",
  "border-radius": "2px",
  "padding-top": "8px",
  "padding-bottom": "8px",
  "padding-left": "24px",
  "padding-right": "24px",
  font: "--base"
});